function Unauthorized() {
  return (
    <>
      <h2>Erreur : non authorisé</h2>
    </>
  );
}

export default Unauthorized;
